import { WORLD_ROUTES, WorldCapabilitiesSchema } from "@uzverse/contracts";
import type { WorldCapabilities } from "@uzverse/contracts";
import { mockCapabilities } from "./mock-api.js";

/** What the user may do in the world (drives which handles and modes the UI offers). */
export async function fetchCapabilities(signal?: AbortSignal): Promise<WorldCapabilities> {
  if (import.meta.env["VITE_UZ_MOCK"] === "1") return mockCapabilities();
  const response = await fetch(WORLD_ROUTES.capabilities, {
    credentials: "same-origin",
    ...(signal ? { signal } : {}),
  });
  if (!response.ok) throw new Error(`world capabilities: ${response.status}`);
  return WorldCapabilitiesSchema.parse(await response.json());
}

/** The outcome of a world tool call as the blueprint needs it (see `invokeWorldTool` in `data.ts`). */
export interface InvokeResult {
  /** The tool's output. */
  output: unknown;
  /** The correlation group of the change, when the service reports it (needed for `history.undo`). */
  correlationId: string | null;
}
